module.exports = __webpack_public_path__ + "static/media/23b.800b1cd8.jpg";